import { useState, useEffect } from 'react'
// import { toast } from 'react-toastify';

export const useFetchAllPaymentReception = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataPaymentReception, setDataPaymentReception] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllPaymentReception, setLoadingFetchAllPaymentReception ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/legal-notarial/fetch-bank-slips-pending`)
            // console.log('[useFetchData][useFetchAllPaymentReception] bank-sli response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllPaymentReception(true)
        fetchData()
            .then((resp) => {
                setDataPaymentReception(resp.rows)
                setLoadingFetchAllPaymentReception(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllPaymentReception(false)
            })
    }, [execute])

    return { dataPaymentReception, loadingFetchAllPaymentReception, executeFetch }

}

export const useFetchSpecificPaymentReception = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificPaymentReception, setLoadingFetchSpecificPaymentReception ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idtransaction: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal-notarial/fetch-specific-lawyer-payment/${paramsToSearch.idtransaction}`)
            // console.log('[useFetchData][useFetchSpecificPaymentReception] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idtransaction > 0 ){
            setLoadingFetchSpecificPaymentReception(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idtransaction: rows[0].idtransaction || '',
                        idlawyer: rows[0].idlawyer || '',
                        idcaja: rows[0].idcaja || '',
                        idbanco: rows[0].idbanco || '',
                        movimiento_fecha: rows[0].movimiento_fecha || '',
                        movimiento_usuario: rows[0].movimiento_usuario || '',
                        movimiento_tipo: rows[0].movimiento_tipo || '',
                        movimiento_monto: rows[0].movimiento_monto || '',
                        movimiento_moneda: rows[0].movimiento_moneda || '',
                        movimiento_tipo_cambio: rows[0].movimiento_tipo_cambio || '',
                        movimiento_quetzales: rows[0].movimiento_quetzales || '',
                        movimiento_dolares: rows[0].movimiento_dolares || '',
                        movimiento_observaciones: rows[0].movimiento_observaciones || '',
                        boleta_numero: rows[0].boleta_numero || '',
                        boleta_foto_originalname: rows[0].boleta_foto_originalname || '',
                        boleta_foto_filename: rows[0].boleta_foto_filename || '',
                        boleta_foto_path: rows[0].boleta_foto_path || '',
                        aprobacion_check: rows[0].aprobacion_check || '',
                        aprobacion_usuario: rows[0].aprobacion_usuario || '',
                        aprobacion_fecha: rows[0].aprobacion_fecha || '',
                        aprobacion_referencia_ach: rows[0].aprobacion_referencia_ach || '',
                        aprobacion_observaciones: rows[0].aprobacion_observaciones || ''
                    }))
                    setLoadingFetchSpecificPaymentReception(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificPaymentReception(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificPaymentReception, setParamsToSearch, executeFetch }

}

export const useFetchInfoForProcessLawyer = ({marvarApi, dispatch, onLogout, paramsURL}) => {

    const { idlawyer } = paramsURL

    // 1. Para los datos recuperados de la BD
    const [dataInfoProcessLawyer, setDataInfoProcessLawyer] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoProcessLawyer, setLoadingFetchInfoProcessLaywer ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/legal-notarial/fetch-info-for-process-lawyer/${idlawyer}`)
            // console.log('[useFetchData][useFetchInfoForProcessLawyer] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchInfoProcessLaywer(true)
        fetchData()
            .then((resp) => {
                setDataInfoProcessLawyer(resp.rows)
                setLoadingFetchInfoProcessLaywer(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchInfoProcessLaywer(false)
            })
    }, [execute])

    return { dataInfoProcessLawyer, loadingFetchInfoProcessLawyer, executeFetch }

}

export const useFetchAllBanks = ({marvarApi, dispatch, onLogout}) => {
    
    const [banks, setBanks] = useState([])

    const [ loadingFetchBanks, setLoadingFetchBanks ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setBanks([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/legal-notarial/fetch-all-banks`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchBanks(true)
        fetchData()
            .then((resp) => {
                setBanks(resp.rows)
                setLoadingFetchBanks(false)

            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchBanks(false)
            })
    }, [execute])

    return { banks, loadingFetchBanks, executeFetch, resetFetch }
}

export const useFetchAllCashRegisters = ({marvarApi, dispatch, onLogout}) => {
    
    const [cashRegisters, setCashRegisters] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setCashRegisters([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/legal-notarial/fetch-all-cash-registers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCashRegisters(true)
        fetchData()
            .then((resp) => {
                setCashRegisters(resp.rows)
                setLoadingFetchCashRegisters(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCashRegisters(false)
            })
    }, [execute])

    return { cashRegisters, loadingFetchCashRegisters, executeFetch, resetFetch }
}